<template>
  <div class="confirmationContainer px-4 px-sm-10">
    <div class="statusWrapper">
      <div v-if="isSuccess" class="statusTextWrapper">
        <slot name="success"></slot>
      </div>
      <div v-else-if="isSuccess === false">
        <slot name="error"></slot>
      </div>
      <v-progress-circular
        v-if="loading"
        width="3"
        size="50"
        indeterminate
        color="#FFA903"
      />
      <v-icon v-else large :color="isSuccess ? 'success' : 'error'">
        {{ isSuccess ? "mdi-check" : "mdi-alert-circle-outline" }}
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationLayout",
  props: ["isSuccess", "loading"]
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";

.confirmationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding-top: 100px;
  background: url("../../assets/img/confirmation_bg.jpg");
  background-size: cover;
}

.statusWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -100px;
}

.statusTextWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  max-width: 480px;
}
</style>
